import moment from 'moment'

export default chartInfo

/** @ngInject */
function chartInfo(Chart, ApiService, DeviceChecker) {
    return ({
        restrict: 'E',
        template: require('./chartInfo.jade')(),
        scope: {
            hasPot: '=',
            userInfo: '=',
            data: '=info',
        },
        link($scope) {
            $scope.isMobile = DeviceChecker.isMobile

            $scope.$watch('userInfo', () => {
                if ($scope.userInfo.contractSelected) {
                    $scope.userIsBase = $scope.userInfo.contractSelected.plan === 'Base'
                    $scope.isLinkyCommunicating = $scope.userInfo.contractSelected.prm.communicating
                    if ($scope.userInfo.contractSelected.nextPayment) {
                        $scope.paymentDay = moment($scope.userInfo.contractSelected.nextPayment.date).date()
                        $scope.paymentMoment = moment($scope.userInfo.contractSelected.nextPayment.date).format('DD MMMM YYYY')
                    }
                }
            })

            return Chart.watch.activeIndex((newIndex) => {
                if ($scope.data) {
                    $scope.info = $scope.data[newIndex]
                    if (!$scope.$$phase) {
                        $scope.$digest()
                    }
                }
            })
        },
    })
}



// WEBPACK FOOTER //
// ./src/directives/chart-info/chartInfo.js